import React from 'react';

import clsx from 'classnames';
import PropTypes from 'prop-types';

import {
    capitalize,
    combineClasses,
} from 'wanderu-css';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './ListPart.scss';

function ListPart(props) {
    const {
        align = 'center',
        className,
        classes: classesProp = {},
        component: Component = 'span',
        componentProps,
        justify = 'center',
        ...otherProps
    } = props;

    const classes = combineClasses(styles, classesProp);

    return (
        <Component
            className={clsx(
                classes.root,
                {
                    [classes[`align${capitalize(align)}`]]: align !== 'center',
                    [classes[`justify${capitalize(justify)}`]]: justify !== 'center',
                },
                className,
            )}
            {...otherProps}
            {...componentProps}
        />
    );
}

ListPart.propTypes = {
    /**
     * Sets the align-self property to control the vertical positioning
     */
    align: PropTypes.oneOf(['center', 'end', 'start']),
    /**
     * The content of the list part.
     */
    children: PropTypes.node,
    /**
     * Override or extend the styles applied to the component.
     */
    classes: PropTypes.object,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * The component used for the root node.
     * Either a string to use a HTML element or a component.
     */
    component: PropTypes.elementType,
    componentProps: PropTypes.object,
    /**
     * Sets the justify-content property to control the horizontal positioning
     */
    justify: PropTypes.oneOf(['center', 'end', 'start']),
};

export default ListPart;
